import { observable, autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';
import { DateTimeValue } from 'app/shared/lib/date-time';


@autoinject()
export class DemoEssTimePage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected id: guid = guid();
    private utcNow = DateTimeValue.now();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 2 ********************************************////
    protected ex2DateTime: string | null = new Date().toJSON();

    ////****************** Example 3 ********************************************////
    protected ex3Time?: string | null = null;
    protected ex3MinTime?: string | null = "06:00";
    protected ex3MaxTime?: string | null = "18:00";

    ////****************** Example 4 ********************************************////
    protected ex4Time?: string | null = null;
    protected ex4MinDateTime?: string | null = this.utcNow.add(-3, 'hours').toString();
    protected ex4MaxDateTime?: string | null = this.utcNow.add(3, 'hours').toString();

    ////****************** Example 99 ********************************************////
    protected ex99Label: string | null = 'Select a Time';
    protected ex99RequiredValidatorLabel: string | null = 'Time';

}
